import { get_module_entity_action_middleware_without_bff } from "./middleware_services";
import OMNIX_MODULE from "constants/OMNIX_MODULE";

// Helper to normalize country (remove accents, uppercase)
const normalizeCountry = (country: string): string => {
  return country.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
}

export const fetchRegions = async (country: string, token: string): Promise<string[]> => {
  try {
    const response = await get_module_entity_action_middleware_without_bff(
      OMNIX_MODULE.OLM,
      'locations',
      { criteria0: normalizeCountry(country) },
      token
    );

    if (response.data.code !== 200) {
      return [];
    }

    return response.data.message;
  } catch (error) {
    console.error('Error fetching regions:', error);
    return [];
  }
};

export const fetchCommunes = async (country: string, region: string, token: string): Promise<any[]> => {
  try {
    const response = await get_module_entity_action_middleware_without_bff(
      OMNIX_MODULE.OLM,
      'locations',
      { criteria0: normalizeCountry(country), criteria1: region },
      token
    );

    if (response.data.code !== 200) {
      return [];
    }

    return response.data.message;
  } catch (error) {
    console.error('Error fetching communes:', error);
    return [];
  }
};

export const fetchCommuneDetails = async (commune: string, token: string): Promise<any | null> => {
  try {
    // We use the middleware client to reach the locations/all endpoint
    // Assuming /bff/olm/locations/all proxies to the same service as mapas 
    // or we use the direct middleware integration pattern

    // Using axiosClientMiddleware directly as seen in polygon_services
    const { axiosClientMiddleware } = require("config/axios/AxiosClient");

    const response = await axiosClientMiddleware.post(
      '/olm/locations/all',
      {
        skipRecords: 0,
        maxRecords: 1,
        project: ["coordinates"], // project might be optional or supported
        filter: {
          criteria3: commune
        }
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.data || response.data.code !== 200) {
      return null;
    }

    if (!response.data.message?.records?.length) {
      return null;
    }

    const record = response.data.message.records[0];
    if (!record.coordinates?.center && !record.coordinates?.area) {
      return null;
    }

    return {
      coordinates: record.coordinates,
      id: record.id,
      name: record.criteria3 // Assuming criteria3 matches the name
    };

  } catch (error) {
    console.error('Error fetching commune details:', error);
    return null;
  }
};

export const fetchCoverages = async (country: string, commune: string | undefined, token: string): Promise<string[]> => {
  try {
    const { axiosClientMiddleware } = require("config/axios/AxiosClient");

    // Build the data object conditionally
    const data: { criteria0: string; criteria3?: string } = {
      criteria0: normalizeCountry(country)
    };

    // Only add criteria3 if commune is provided
    if (commune) {
      data.criteria3 = commune;
    }

    console.log('fetchCoverages: Calling endpoint /olm/routes/coverages/all with data:', data);

    const response = await axiosClientMiddleware.post(
      '/olm/routes/coverages/all',
      {
        skipRecords: 0,
        maxRecords: 50,
        project: ["id"],
        filter: {
          route: {
            target: {
              type: "Location",
              data
            }
          }
        }
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    console.log('fetchCoverages: Response status:', response?.status || response?.data?.code);

    if (!response.data || response.data.code !== 200) {
      console.warn('fetchCoverages: Invalid response or code != 200', response?.data);
      return [];
    }

    // Adjust based on typical omnix response structure if different, but assuming similar to maps
    const records = response.data.message.records;
    console.log('fetchCoverages: Records found:', records?.length);
    return records.map((record: any) => record.id);
  } catch (error) {
    console.error('Error fetching coverages:', error);
    return [];
  }
};
